angular
	.module 'App.Repository'
	.factory 'ReportRepository', ['RenderRepository', 'BaseRepository', (RenderRepository, BaseRepository) ->
		class ReportRepository extends BaseRepository
			@resource = '/reports'
			@isRestricted = true

			download: (fileId) ->
				return RenderRepository.downloadFromUrl @toString(null, "/files/#{fileId}/download")

		return new ReportRepository
	]
